/**
 * Append or replace a query-string parameter in a URL.
 *
 * @param {string} uri - The URL to modify.
 * @param {string} key - The parameter name.
 * @param {number | string} value - The parameter value.
 * @returns {string} The updated URL.
 */
function updateQueryStringParameter(uri, key, value) {
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, "i");
    const separator = uri.includes("?") ? "&" : "?";

    if (uri.match(re)) {
        return uri.replace(re, `$1${key}=${value}$2`);
    }

    return `${uri}${separator}${key}=${value}`;
}

/**
 * Bind the elastic search grid's pagination buttons and sort dropdown, then
 * initialise the shared search view.
 *
 * @param {number} pageNumber - The current page number.
 * @param {number} maxPageNumber - The last available page number.
 * @returns {void}
 */
function initElasticProductGrid(pageNumber, maxPageNumber) {
    document.querySelectorAll(".previous-page-elastic").forEach((item) => {
        item.addEventListener("click", () => {
            const newPageNumber = pageNumber - 1;
            if (newPageNumber <= 0) return;
            window.location.href = updateQueryStringParameter(
                window.location.href,
                "page",
                newPageNumber,
            );
        });
    });

    document.querySelectorAll(".next-page-elastic").forEach((item) => {
        item.addEventListener("click", () => {
            const newPageNumber = pageNumber + 1;
            if (newPageNumber > maxPageNumber) return;
            window.location.href = updateQueryStringParameter(
                window.location.href,
                "page",
                newPageNumber,
            );
        });
    });

    document
        .getElementById("products-sort")
        ?.addEventListener("change", (event) => {
            const target = /** @type {HTMLSelectElement} */ (event.target);
            const url = new URL(window.location.href);
            url.searchParams.set("sort", target.value);
            window.location.href = url.toString();
        });

    window.initSearchView();
}

window.initElasticProductGrid = initElasticProductGrid;

export {};
